import React from 'react';
import PropTypes from 'prop-types';
var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var Embed = function (_React$Component) {
  inherits(Embed, _React$Component);
  function Embed() {
    var _ref;
    var _temp, _this, _ret;
    classCallCheck(this, Embed);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Embed.__proto__ || Object.getPrototypeOf(Embed)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = function () {
      var element = _this.wrapper;
      var options = _extends({}, _this.props, {
        element: element
      });
      _this.embed = RunKit.createNotebook(options);
    }, _this.componentWillUnmount = function () {
      if (_this.embed) {
        _this.embed.destroy();
        _this.embed = null;
      }
    }, _this.componentDidUpdate = function (prevProps) {
      if (_this.embed) {
        if (prevProps.source !== _this.props.source) {
          _this.embed.setSource(_this.props.source);
        }
        if (prevProps.preamble !== _this.props.preamble) {
          _this.embed.setPreamble(_this.props.preamble);
        }
      }
    }, _this.evaluate = function (callback) {
      if (_this.embed) {
        _this.embed.evaluate(callback);
      }
    }, _this.getSource = function (callback) {
      if (_this.embed) {
        _this.embed.getSource(callback);
      }
    }, _this.getURL = function () {
      if (_this.embed) {
        return _this.embed.URL;
      }
    }, _this.render = function () {
      return React.createElement('div', {
        ref: function ref(instance) {
          return _this.wrapper = instance;
        }
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }
  return Embed;
}(React.Component);
Embed.propTypes = {
  source: PropTypes.string,
  readOnly: PropTypes.bool,
  mode: PropTypes.string,
  nodeVersion: PropTypes.string,
  env: PropTypes.array,
  title: PropTypes.string,
  minHeight: PropTypes.string,
  packageTimestamp: PropTypes.string,
  preamble: PropTypes.string,
  onLoad: PropTypes.func,
  onURLChanged: PropTypes.func,
  onEvaluate: PropTypes.func
};
export default Embed;